import React, { useState } from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';

import Base from '@/templates/Base/Base';

import Hero from '@Themes/natucare/modules/Hero/Hero';
import HeroSlider from '@Themes/natucare/modules/HeroSlider/HeroSlider';
import Mediabar from '@Themes/natucare/modules/Mediabar/Mediabar';
import ProductCollectionsLinks from '@Themes/natucare/modules/ProductCollectionsLinks/ProductCollectionsLinks';
import FeatureContent from '@Themes/natucare/modules/FeatureContent/FeatureContent';
import TestimonialsVideo from '@Themes/natucare/modules/TestimonialsVideo/TestimonialsVideo';
import ReviewsWeb from '@Themes/natucare/modules/ReviewsWeb/ReviewsWeb';
import ProductHighlight from '@Themes/natucare/modules/ProductHighlight/ProductHighlight';
import MediaSocial from '@Themes/natucare/modules/MediaSocial/MediaSocial';
import Blog from '@Themes/natucare/modules/Blog/Blog';

import Seo from '@/components/Seo/Seo';

import { parsePosts } from '@/templates/Blog/utils/parsePosts';

import DATA from '@/data/pl/index.data';

const HomePage = props => {
  const postsModel = get(props, 'data');
  const { headerData, footerData } = props.pageContext;

  const blogPosts = {
    subheading: 'Blog',
    heading: 'Poznaj swoje ciało',
    text: 'Nasz Blog, to Twoja bezpieczna przestrzeń stworzona specjalnie, abyś mogła lepiej poznać i zrozumieć swoje ciało. Każdy artykul powstał we współpracy z najlepszymi ekspertami w swojej dziedzinie - od dietetyków klinicznych po ginekologów. ',
    tabs: [
      { label: 'Kolagen', actions: { button: { href: '/pl/kolagen', label: 'Zobacz więcej' } }, items: parsePosts({ postsModel: postsModel.kolagen.edges }) },
      {
        label: 'Omega-3',
        actions: { button: { href: '/pl/omega', label: 'Zobacz więcej' } },
        items: [
          ...(parsePosts({
            postsModel: postsModel.omega.edges,
          })),
          ...(parsePosts({ postsModel: postsModel.omegaItems.edges }))
        ]
      },
      {
        label: 'Białko',
        actions: { button: { href: '/pl/bialko', label: 'Zobacz więcej' } },
        items: [
          ...(parsePosts({
            postsModel: postsModel.bialko.edges,
          })),
          ...(parsePosts({ postsModel: postsModel.bialkoItems.edges }))
        ]
      },
      { label: 'Przepisy kulinarne', actions: { button: { href: '/pl/przepisy', label: 'Zobacz więcej' } }, items: parsePosts({ postsModel: postsModel.przepisy.edges }) }
    ]
  };

  const [subscriptionStatus, setSubscriptionStatus] = useState({
    isSending: false,
    isSubscribed: false,
    isEmailTaken: false
  });

  const handleSubscribeNewsletter = async (email, tags = 'newsletter') => {
    setSubscriptionStatus({
      isSending: true,
      isSubscribed: false,
      isEmailTaken: false
    });

    try {
      const response = await fetch('/api/subscribe-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          tags
        })
      });

      const data = await response.json();


      setSubscriptionStatus({
        isSending: false,
        isSubscribed: !data.errorCode,
        isEmailTaken: data.errorCode === 'EMAIL_ALREADY_TAKEN'
      });

      if (typeof data.errorCode === 'undefined' && data?.errorCode !== 'EMAIL_ALREADY_TAKEN') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'subscribe_nwl' });
      }

    } catch (error) {
      setSubscriptionStatus({
        isSending: false,
        isSubscribed: false,
        isEmailTaken: false
      });
    }
  };

  DATA.featureContent[2].actions.newsletterForm.onSubscribe = handleSubscribeNewsletter;
  DATA.featureContent[2].actions.newsletterForm.subscriptionStatus = subscriptionStatus;

  return <Base headerData={headerData} footerData={footerData} tidio isKlaviyoPl={true}>
    <Seo
      lang='pl'
      title='Natu.Care - Suplementy Premium'
      description='Natu.Care powstało po to, aby zapewnić kompleksowe wsparcie dla Twojego organizmu. Nasze produkty zawierają wyłącznie niezbędne do prawidłowego funkcjonowania składniki.'
      structuredData={DATA.schema}
      hrefLang={DATA.hrefLang}
    />

    {DATA.hero.length > 1 ? (
      <HeroSlider slides={DATA.hero.map((item, index) => (
        <Hero {...item} key={`slide${index + 1}`} />
      ))} />
    ) : (
      <Hero {...DATA.hero[0]} />
    )}
    <Mediabar {...DATA.mediabar} />
    <ProductCollectionsLinks {...DATA.productCollectionsLinks} />
    <ProductHighlight {...DATA.productHighlight} />
    <FeatureContent {...DATA.featureContent[0]} />
    <FeatureContent {...DATA.featureContent[1]} />
    <TestimonialsVideo {...DATA.testimonialsVideo} />
    <ReviewsWeb {...DATA.reviewsWeb} />
    <FeatureContent {...DATA.featureContent[2]} />
    <MediaSocial {...DATA.mediaSocial} />
    <Blog {...blogPosts} />
  </Base>;
};

export default HomePage;

export const pageQuery = graphql`

query GetPostsForHomepage($locale: String! = "pl") {
  kolagen: allStrapiBlogPost(
    limit: 6
    filter: {
      locale: {eq: "pl"},
      slug: {ne: null},
      options: {strapi_json_value: {nin: "hideInListing"}},
      category: {slug: {eq: "kolagen"}},
      strapi_id: { in: [ 1428, 902, 1362, 1196, 888, 982 ]}
    }
    sort: {createdAtCustom: DESC}
  ) {
    edges {
      node {
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        category {
          slug
          heading
          shortHeading
        }
        createdAtFullDate: createdAtCustom(locale: $locale, formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      }
    }
  }

 omega: allStrapiBlogList(
    limit: 1
    filter: {
      locale: {eq: "pl"},
      slug: {ne: null},
      options: {strapi_json_value: {nin: "hideInListing"}},
      strapi_id: { eq: 15}
    }
    sort: {createdAtCustom: DESC}
  ) {
    edges {
      node {
        strapi_id
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        createdAtFullDate: createdAtCustom(locale: "pl", formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: "pl", formatString: "YYYY-MM-DD")
      }
    }
  }

  omegaItems: allStrapiBlogPost(
    limit: 6
    filter: {
      locale: {eq: "pl"}, 
      slug: {ne: null}, 
      options: {strapi_json_value: {nin: "hideInListing"}}, 
      category: {slug: {eq: "omega"}},
      strapi_id: { in: [ 980, 998, 1056, 1376, 994 ]}
    }
    sort: {createdAtCustom: DESC},
  ) {
    edges {
      node {
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        category {
          slug
          heading
          shortHeading
        }
        createdAtFullDate: createdAtCustom(locale: $locale, formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      }
    }
  }
  
 bialko: allStrapiBlogList(
    limit: 1
    filter: {
      locale: {eq: "pl"},
      slug: {ne: null},
      options: {strapi_json_value: {nin: "hideInListing"}},
      strapi_id: { eq: 25}

    }
    sort: {createdAtCustom: DESC}
  ) {
    edges {
      node {
        strapi_id
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        createdAtFullDate: createdAtCustom(locale: "pl", formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: "pl", formatString: "YYYY-MM-DD")
      }
    }
  }

  bialkoItems: allStrapiBlogPost(
    limit: 6
    filter: {
      locale: {eq: "pl"}, 
      slug: {ne: null}, 
      options: {strapi_json_value: {nin: "hideInListing"}}
      category: {slug: {eq: "bialko"}},
      strapi_id: { in: [ 1444, 1328, 1330, 1336, 940 ]}

    }
    sort: {createdAtCustom: DESC}
  ) {
    edges {
      node {
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        category {
          slug
          heading
          shortHeading
        }
        createdAtFullDate: createdAtCustom(locale: $locale, formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      }
    }
  }
    
  
  przepisy: allStrapiBlogPost(
    limit: 6
    filter: {locale: {eq: "pl"}, slug: {ne: null}, options: {strapi_json_value: {nin: "hideInListing"}}, category: {slug: {eq: "przepisy"}}}
    sort: {createdAtCustom: DESC}
  ) {
    edges {
      node {
        locale
        slug
        shortHeading
        heading
        shortContent
        seo {
          title
        }
        thumbnailImage {
          url
        }
        category {
          slug
          heading
          shortHeading
        }
        createdAtFullDate: createdAtCustom(locale: $locale, formatString: "DD MMMM")
        dateFormat: createdAtCustom(locale: $locale, formatString: "YYYY-MM-DD")
      }
    }
  }
}
`;
